import React from "react";
import SummaryCard from "./SummaryCard";
import { formatCurrency, formatMonthsToYearsMonths } from "../utils/formatters";

const SummarySection = ({ summary, monthlyExtraPayment, rateType }) => (
  <div className="summary-section">
    <h2 className="section-title gradient-title">Loan Summary</h2>

    <div className="summary-grid">
      <SummaryCard
        icon="📅"
        label={rateType === "floating" ? "Average EMI" : "Monthly EMI"}
        value={formatCurrency(summary.emi)}
        accentColor="var(--primary)"
        badge="per month"
      />
      <SummaryCard
        icon="➕"
        label="Monthly Extra"
        value={formatCurrency(monthlyExtraPayment)}
        accentColor="var(--purple)"
        badge="prepayment"
      />
      <SummaryCard
        icon="💸"
        label="Total Interest"
        value={formatCurrency(summary.totalInterest)}
        accentColor="var(--danger)"
      />
      <SummaryCard
        icon="💰"
        label="Interest Saved"
        value={formatCurrency(summary.interestSaved)}
        accentColor="var(--success)"
        badge={summary.interestSaved > 0 ? "saved!" : undefined}
      />
      <SummaryCard
        icon="📆"
        label="Actual Loan Period"
        value={formatMonthsToYearsMonths(summary.monthsCompleted)}
        accentColor="var(--purple)"
      />
      <SummaryCard
        icon="⏱️"
        label="Time Saved"
        value={formatMonthsToYearsMonths(summary.monthsSaved)}
        accentColor="var(--success)"
        badge={summary.monthsSaved > 0 ? "early closure" : undefined}
      />
      {rateType === "floating" && (
        <SummaryCard
          icon="📊"
          label="Rate Changes"
          value={String(summary.rateChanges || 0)}
          accentColor="var(--purple)"
        />
      )}
      <SummaryCard
        icon="🧾"
        label="Total Amount Payable"
        value={formatCurrency(summary.totalPayable)}
        accentColor="var(--primary)"
      />
    </div>
  </div>
);

export default SummarySection;
